import type { Permission } from '@ztechapps/common.contract'

export const productPermissions = {
  canView: {
    value: 'product.canView',
    label: 'Can View',
    description: 'No modification can be done to the product, only viewing of details.',
  } satisfies Permission,
  canEdit: {
    value: 'product.canEdit',
    label: 'Can Edit',
    description: 'Can modify the records for all fields of product',
  } satisfies Permission,
  canDelete: {
    value: 'product.canDelete',
    label: 'Can Delete',
    description: 'Can delete products. This will delete the entire record and cannot be recovered.',
  } satisfies Permission,
}
